import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import StatusCode from "../../../util/StatusCode";
import TableHorizontal, { InfoObject } from "../../misc/TableHorizontal";
import { UserTrackings } from "../../../store/ScheduleSync/ScheduleSyncUserAction";
import { ScheduleSync_CoreTrackings } from "../../../models/CoreScheduleSyncModels";
import { RequestState } from "../../../models/RequestState";
import * as Helper from '../../../util/Helper';
import { useTranslation } from 'react-i18next';
import { RootState } from "../../../store/store";



const ScheduleSyncUserTrackings = () => {
    const { t } = useTranslation(['scheduleSync', 'common']);

    const { userId } = useParams();
    const dispatch = useDispatch();
    const trackings = useSelector<RootState, RequestState<ScheduleSync_CoreTrackings>>(state => state.schedulesync_users.userTrackings);

    useEffect(() => {
        if (userId) {
            UserTrackings(userId)(dispatch);
        }
    }, [dispatch, userId]);

    const mapTrackings = (): InfoObject[] => {

        if (trackings.code !== StatusCode.COMPLETE) {
            return [];
        }

        let combineTrackings = [];
        trackings.data.exportTrackings?.map(et => {
            combineTrackings.push(et)
        })
        combineTrackings.push(trackings.data?.importTracking)

        return combineTrackings.map<InfoObject>((tracking, i) => ({
            id: tracking?.targetId ?? i.toString(),
            data: [
                { value: tracking?.targetSystem },
                { value: tracking?.targetId },
                { value: tracking?.targetData },
                { value: Helper.formatDate(tracking?.exported) },
                { value: tracking?.active ? Helper.active(tracking.active) : '-' },
            ]
        }));
    }

    return (<>
        <h5 className="header-menu">{t('tracking.title', { ns: 'scheduleSync' })}</h5>
        <TableHorizontal
            header={[{ value: t('tracking.tableHeaders.targetSystem', { ns: 'scheduleSync' }) }, { value: t('tracking.tableHeaders.targetId', { ns: 'scheduleSync' }) }, { value: t('tracking.tableHeaders.targetData', { ns: 'scheduleSync' }) }, { value: t('tracking.tableHeaders.exported', { ns: 'scheduleSync' }) }, { value: t('genericTableHeaders.active', { ns: 'common' }) }]}
            info={mapTrackings()}
            error={trackings.code === StatusCode.ERROR}
            searching={trackings.code === StatusCode.PENDING}
            noResMsg={t('noResult.userTrackings', { ns: 'scheduleSync' })}
        />
    </>)
}

export default ScheduleSyncUserTrackings;
